import React, { useState, useEffect } from "react";
import {
  Space,
  Table,
  Form,
  theme,
  Row,
  Button,
  Col,
  Input,
  message,
  DatePicker,
} from "antd";
import axios from "axios";
import moment from "moment/moment";
import localhost from "../../constants/localhost";
import Detail from "./detail";

const mockData = Array(10)
  .fill(null)
  .map((_, index) => {
    return {
      id: index,
      name: "世界杯001",
      type: "圈子类型",
      circleOwner: "叶玫瑰",
      featuredFlag: "1",
      dataIndex: "10086",
      contentCount: "10008611",
      establishmentDate: "2024-10-03",
      status: "1",
    };
  });

const CommunityGroup = () => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const [dataInfo, setDataInfo] = useState({
    total: 20,
    dataSource: mockData,
  });
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    const formData = form.getFieldsValue();
    if (formData.establishmentDate) {
      formData.establishmentDateStart = moment(
        formData.establishmentDate[0]
      ).format("YYYY-MM-DD");
      formData.establishmentDateEnd = moment(
        formData.establishmentDate[1]
      ).format("YYYY-MM-DD");
      formData.reportDate = undefined;
    }
    axios
      .post(`${localhost}/manage/circleManage/queryList`, {
        pageNo: 1,
        pageSize: 20,
        ...formData,
      })
      .then((res) => {
        setDataInfo({
          total: res?.data?.total || 0,
          dataSource: res?.data?.list || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        message.error("网络异常，请重试！");
        setLoading(false);
      });
  };

  const pagination = {
    showTotal: (total, range) => {
      return `当前第 ${range[0]} 到 ${range[1]} 条，总共${total}条数据`;
    },
    total: dataInfo.total,
    current: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
    onChange: (page, pageSize) => {
      setPageInfo({ pageNo: page, pageSize: pageSize }, () => {
        getData();
      });
    },
    onShowSizeChange: (current, size) => {
      setPageInfo({ pageNo: current, pageSize: size }, () => {
        getData();
      });
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const onSearch = () => {
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const onReset = () => {
    form.resetFields();
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const formStyle = {
    maxWidth: "none",
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const setDisplay = ({ id, status }) => {
    axios
      .get(
        `${localhost}/manage/circleManage/updateStatus?id=${id}&status=${status}`
      )
      .then((res) => {
        message.success(`${status === 1 ? "上架" : "下架"}成功！`);
        getData();
      });
  };

  const setFlag = ({ id, status }) => {
    axios
      .get(
        `${localhost}/manage/circleManage/updateFeaturedFlag?id=${id}&featuredFlag=${status}`
      )
      .then((res) => {
        message.success(`${status === 1 ? "加精" : "取消精选"}成功！`);
        getData();
      });
  };

  const columns = [
    {
      title: "圈子ID",
      dataIndex: "id",
      minWidth: 150,
    },
    {
      title: "圈子名称",
      dataIndex: "name",
      minWidth: 150,
    },
    {
      title: "类型",
      dataIndex: "type",
      minWidth: 150,
    },
    {
      title: "圈主",
      dataIndex: "circleOwner",
      minWidth: 150,
    },
    {
      title: "加精",
      dataIndex: "featuredFlag",
      minWidth: 150,
      render: (status) => (status ? "精选" : "未精选"),
    },
    {
      title: "圈子用户数",
      dataIndex: "userCount",
      minWidth: 150,
    },
    {
      title: "圈子内容数",
      dataIndex: "contentCount",
      minWidth: 150,
    },
    {
      title: "圈子成立时间",
      dataIndex: "establishmentDate",
      minWidth: 150,
    },
    {
      title: "发布状态",
      dataIndex: "status",
      minWidth: 150,
      render: (status) => (!status ? "已下架" : "已上架"),
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Detail detail={record} />
          {record.status === 1 ? (
            <a
              onClick={() => {
                setDisplay({ id: record.id, status: 0 });
              }}
            >
              下架
            </a>
          ) : (
            <a
              onClick={() => {
                setDisplay({ id: record.id, status: 1 });
              }}
            >
              上架
            </a>
          )}
          {record.featuredFlag === 1 ? (
            <a
              onClick={() => {
                setFlag({ id: record.id, status: 0 });
              }}
            >
              取消精选
            </a>
          ) : (
            <a
              onClick={() => {
                setFlag({ id: record.id, status: 1 });
              }}
            >
              加精
            </a>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Form
          form={form}
          name="advanced_search"
          style={formStyle}
          onFinish={onFinish}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="name" label="圈子名称">
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="type" label="圈子类型">
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="establishmentDate" label="成立时间">
                <DatePicker.RangePicker />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="circleOwner" label="圈主">
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col span={16}>
              <div style={{ textAlign: "right" }}>
                <Space size="small">
                  <Button type="primary" onClick={onSearch}>
                    搜索
                  </Button>
                  <Button onClick={onReset}>重置</Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <div style={{ marginTop: 16 }}>
        <Table
          columns={columns}
          scroll={{ x: "max-content", y: "calc(100vh - 240px - 55px - 64px)" }}
          style={{
            height: "calc(100vh - 240px)",
            overflowY: "scroll",
          }}
          rowSelection={{
            selectedRowKeys,
            onChange: (keys, selectedRows) => {
              console.log("selectedRowKeys changed: ", keys);
              setSelectedRowKeys(keys);
            },
          }}
          // loading={loading}
          dataSource={dataInfo.dataSource}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default CommunityGroup;
